require('./src/styles/global.scss');
const React = require("react");

const { default: Layout } = require('./src/layout/layout');

// Wraps every page in a component
exports.wrapPageElement = ({ element, props }) => {
    return <Layout pageTitle={element?.type?.pageTitle || ''} {...props}>{element}</Layout>
}